import BackToTop from "./BackToTop";
import Footer from "./Footer";
import Header from "./Header";

// Shared page chrome: sticky header, page content, footer.
export default function Layout({ children }) {
  return (
    <>
      <Header />
      <main className="wrap">{children}</main>
      <Footer />
      <BackToTop />
    </>
  );
}
